
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 40 37","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#111","stroke-width":"2","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M34.51 26.564A13.846 13.846 0 0039 16.545C39 7.995 30.536 1 20 1S1 7.995 1 16.545s8.464 15.546 19 15.546c1.8-.026 3.594-.228 5.355-.605l10.19 4.06-1.036-8.982z"}}),_c('path',{attrs:{"d":"M26.53 11.746A4.232 4.232 0 0020 12.4a4.246 4.246 0 10-6.53 5.36L20 24.318l6.532-6.555a4.265 4.265 0 00-.001-6.017z"}})])])
          )
        }
      }
    